export const initialState: any = {
  VideoName: "",
  IsGenerateHTML: false,
  Comment: "",
  VideoFile: "",
  Height: 500,
  Width: 500
};
